import { z } from 'zod';

export const ConsensusTemplateChange = {
  ColumnDeleted: 'COLUMN_DELETED',
} as const;

export type ConsensusTemplateChange =
  (typeof ConsensusTemplateChange)[keyof typeof ConsensusTemplateChange];

export const ConsensusTemplateSseEventPayloadSchema = z.object({
  change: z.nativeEnum(ConsensusTemplateChange),
  cycleId: z.string(),
  consensusColumnId: z.string(),
  columnName: z.string(),
});

export type ConsensusTemplateSseEventPayload = z.infer<
  typeof ConsensusTemplateSseEventPayloadSchema
>;
